import { FC, PropsWithChildren } from 'react';
import { StyledBanner, StyledBannerContent } from './Banner.styles';

/**
 * A simple banner that designed to sit at the top of a page. Useful for announcments or important information.
 */
export const Banner: FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyledBanner>
      <StyledBannerContent>{children}</StyledBannerContent>
    </StyledBanner>
  );
};

export default Banner;
